<template>
    <div class="card" :style="style">
        <div class="top">
            <p class="text-center q-mt-sm" v-if="article">
                <small>{{article.title}}</small>
            </p>
            <p class="text-center q-mt-sm">
                {{model.title}}
            </p>
            <image-viewer :model="model" :src="model.url" v-if="model.category === 'picture'"/>
            <audio-viewer :model="model" :src="model.url" v-if="model.category === 'audio'"/>
            <video-viewer :model="model" :src="model.url" v-if="model.category === 'video'"/>
        </div>

        <div class="bottom">
            <text-viewer :model="model" :maxHeight="200"/>
        </div>
    </div>
</template>

<script>
    import ImageViewer from './ImageViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import TextViewer from './TextViewer'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import AudioViewer from './AudioViewer'
    import VideoViewer from './VideoViewer'
    export default {
        name: 'ArticlePartViewer',
        components: {VideoViewer, AudioViewer, QCardMain, TextViewer, QCard, ImageViewer},
        props: ['model', 'backgroundUrl', 'backgroundColor'],
        computed: {
            article () {
                return this.$store.getters.article.find(a => a.articleId === this.model.articleId)
            },
            style () {
                let value = ''

                if (this.backgroundUrl || this.backgroundColor) {
                    // from props - higher priority than local model model values
                    if (this.backgroundUrl) {
                        value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.backgroundUrl}); background-size: cover; `
                    }

                    if (this.backgroundColor) {
                        value += `background-color: ${this.backgroundColor}; `
                    }
                } else {
                    if (this.model.backgroundUrl) {
                        value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.model.backgroundUrl}); background-size: cover; `
                    }

                    if (this.model.backgroundColor) {
                        value += `background-color: ${this.model.backgroundColor}; `
                    }
                }

                return value

            }
        }
    }
</script>

<style scoped lang="scss">
    .card {
        border-radius: 20px;
        width: 250px;
        height: 350px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .top {
            height: 100%;
        }

        .bottom {
            height: 100%;
            overflow: hidden;
        }
    }
</style>